import React, { useState } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { ALIGNMENT_TYPES, LEFT, RIGHT } from "../sell/constants";
import { handleKeyPress } from "./helpers/keyPressHelpers";

const TextToggle = ({ onToggle, alignment, leftContent, rightContent }) => {
  const [selectedAlignment, setSelectedAlignment] = useState(alignment);

  const toggle = () => {
    setSelectedAlignment(selectedAlignment === RIGHT ? LEFT : RIGHT);
    onToggle?.();
  };

  return (
    <div
      onKeyPress={(event) => handleKeyPress(event, toggle)}
      role="button"
      tabIndex={0}
      onClick={toggle}
      className="lc-text-toggle"
    >
      <input
        type="checkbox"
        onChange={(event) => handleKeyPress(event, toggle)}
      />
      <span
        aria-label="Left"
        className={classnames("text", { selected: selectedAlignment === LEFT })}
        dangerouslySetInnerHTML={{ __html: leftContent }}
      />
      <span
        aria-label="Right"
        className={classnames("text", {
          selected: selectedAlignment === RIGHT
        })}
        dangerouslySetInnerHTML={{ __html: rightContent }}
      />
    </div>
  );
};

TextToggle.propTypes = {
  alignment: PropTypes.oneOf(ALIGNMENT_TYPES).isRequired,
  leftContent: PropTypes.node.isRequired,
  onToggle: PropTypes.func,
  rightContent: PropTypes.node.isRequired
};

TextToggle.defaultProps = {
  onToggle: null
};

export default TextToggle;
